import { Component, OnInit, Input, AfterContentChecked } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-single-data-card',
  templateUrl: './single-data-card.component.html',
  styleUrls: ['./single-data-card.component.scss']
})
export class SingleDataCardComponent implements  OnInit, AfterContentChecked {

  @Input() value;
  @Input() icon;
  @Input() title;
  showValue: boolean;

  constructor(private spinnerService: SpinnerService) {
    this.showValue = false;
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.spinnerService.show('value-spinner');
    if ((null !== this.value) && (undefined !== this.value) && ('-' !== this.value)) {
      this.spinnerService.hide('value-spinner');
      this.showValue = true;
    } else if ('-' === this.value) {
      this.value = '-';
      this.showValue = true;
      this.spinnerService.hide('value-spinner');
    }
  }

}
